export var JobType;
(function (JobType) {
    JobType["idAml"] = "id-aml";
    JobType["idVerification"] = "id-verification";
    JobType["idReverification"] = "id-reverification";
    JobType["idCrosscheck"] = "id-crosscheck";
    JobType["idAamva"] = "id-aamva";
    JobType["ecbsvSSN"] = "ecbsv-ssn";
    JobType["privateSSN"] = "private-ssn";
    JobType["dob"] = "dob";
    JobType["selfieVerification"] = "selfie-verification";
    JobType["tinValidation"] = "tin-validation";
})(JobType || (JobType = {}));
